export const zh_CN = {
    translation: {
        b: {
            cancel: '取消',
            confirm: '确认',
            send: '发送',
            done: '完成',
            close: '关闭',
            clear: '清除',
            copy_link: '复制链接',
            export: '导出',
            delete: '删除',
            delete_confirm: '确认删除',
            duplicate: '复制',
            share: '分享',
            sign_in: '登录',
            sign_up: '注册',
            email_address: '电子邮件地址',
            yes: '是',
            no: '否'
        },
        m_languages: {
            title: '语言',
            subtitle: '选择一种语言'
        },
        m_feedback: {
            feature: {
                name: '功能请求',
                desc: '缺少你需要的功能？告诉我们——你的想法很重要'
            },
            feedback: {
                name: '反馈',
                desc: '你的反馈对我们非常重要——请留下简短留言'
            }
        },
        m_feedback_t: {
            feature: {
                name: '感谢您的建议！',
                desc: '感谢您抽出时间分享想法——这有助于我们改进。'
            },
            feedback: {
                name: '感谢您的反馈！',
                desc: '感谢您抽出时间分享想法——这有助于我们改进。'
            }
        },
        m_diagram_details: {
            name_place: '输入项目名称',
            desc_place: '输入项目描述'
        },
        m_quick_share: {
            title: '快速分享',
            subtitle: '（基于查询的链接分享）'
        },
        m_export_img: {
            title: '导出图片'
        },
        m_export_code: {
            title: '导出 {{db_engine}} 代码',
            download_file: '下载文件',
            copy_code: '复制代码'
        },
        m_sign_in_remind: {
            title: '感谢尝试 DB Design',
            subtitle: '登录或注册以提高表数量上限、保存图表，并解锁更多功能。'
        },
        m_sign_in_restrict: {
            title: '登录以在应用中完成更多操作',
            subtitle: '登录或注册以提高表格上限、保存图表，并解锁更多功能。'
        },
        m_new_diagram: {
            title: '新建图表',
            subtitle: '选择数据库引擎',
            open_diagram: '打开图表'
        },
        m_keyboard_shortcuts: {
            title: '键盘快捷键',
            ctrl_left: {
                title1: '控件',
                title2: '(左侧)',
                items: {
                    mouse_sel: '鼠标选择 / 手形模式',
                    table: '表',
                    line: '线',
                    area: '区域',
                    note: '备注',
                    comment: '注释',
                    pen: '画笔',
                    undo: '撤销',
                    redo: '重做'
                }
            },
            ctrl_top_left: {
                title1: '控件',
                title2: '(左上角)',
                items: {
                    export_img: '导出图片',
                    search: '搜索',
                    editor_panel: '编辑器面板'
                }
            },
            ctrl_bottom_right: {
                title1: '控件',
                title2: '(右下角)',
                items: {
                    minimap: '小地图',
                    zoom_in: '放大',
                    zoom_out: '缩小',
                    zoom_100: '缩放至 100%'
                }
            },
            ctx_tab: {
                title1: '上下文菜单',
                title2: '(表)',
                items: {
                    dupl_tab: '复制表',
                    del_tab: '删除表'
                }
            },
            ctx_del_tab: {
                title1: '上下文菜单',
                title2: '(删除表)',
                items: {
                    yes: '是',
                    no: '否'
                }
            },
            ctx_tab_col: {
                title1: '上下文菜单',
                title2: '(表列)',
                items: {
                    add_col_below: '在下方添加列',
                    focus_col_above: '将焦点移至上一列',
                    focus_col_below: '将焦点移至下一列',
                    move_col_up: '上移列',
                    move_col_down: '下移列',
                    dupl_col: '复制列',
                    del_col: '删除列'
                }
            },
            ctx_line: {
                title1: '上下文菜单',
                title2: '(线)',
                items: {
                    del_line: '删除连线'
                }
            },
            ctx_area: {
                title1: '上下文菜单',
                title2: '(区域)',
                items: {
                    dupl_area: '复制区域',
                    del_area: '删除区域'
                }
            },
            ctx_multi: {
                title1: '上下文菜单',
                title2: '(多选)',
                items: {
                    select_all: '选择所有元素',
                    create_area_for_select_els: '为所选元素创建区域',
                    dupl_select_els: '复制所选元素',
                    del_select_els: '删除所选元素'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: '鼠标选择',
                table: '表',
                line: '线',
                area: '区域',
                note: '备注（即将推出）',
                comment: '注释（即将推出）',
                pen: '画笔',
                undo: '撤销',
                redo: '重做'
            },
            ctrl_top_left: {
                logo: '注意：这是一个沙盒（测试环境）',
                name: '图表信息',
                editor: '编辑器（即将推出）',
                search: '搜索（即将推出）',
                export: '导出选项',
                view_mode: '查看模式',
                zoom_to_fit: '适配到屏幕'
            },
            ctrl_top_right: {
                feature_req: '功能请求',
                sign_in: '登录',
                quick_share: '快速分享'
            },
            ctrl_bottom_right: {
                full_screen: '全屏',
                minimap: '小地图',
                zoom_out: '缩小',
                zoom_100: '缩放至 100%',
                zoom_in: '放大',
                info: '信息与资源'
            },
            ctx: {
                base: {
                    colors: {
                        default: '默认',
                        blue: '蓝色',
                        green: '绿色',
                        red: '红色',
                        purple: '紫色',
                        violet: '紫罗兰色'
                    },
                    borders: {
                        none: '无',
                        solid: '实线',
                        dashed: '虚线',
                        dotted: '点线'
                    },
                    color: '颜色',
                    border: '边框',
                    description: '描述',
                    description_table_place: '表说明',
                    description_column_place: '列说明',
                    description_line_place: '连线说明',
                    description_note_place: '备注说明',
                    description_area_place: '区域说明',
                    description_pen_place: '画笔说明',
                    hide_menu: '隐藏菜单',
                    show_menu: '显示菜单'
                },
                tab_col: {
                    add_col_below: '在下方添加列',
                    add_col_above: '在上方添加列',
                    key: 'Key',
                    keys: {
                        none: '无',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: '无',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: '下移列',
                    move_col_up: '上移列',
                    more_functions: '更多功能'
                },
                line: {
                    change_connects: '修改连接器',
                    connects: {
                        empty: '空',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: '过滤元素'
                },
                multi: {
                    filter: '过滤所选内容',
                    create_area: '创建区域'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: '完整',
            keys_only: '仅键',
            names_only: '仅名称'
        },
        dropdown_ctrl_export: {
            export_img: '导出图片',
            export_code: '导出 SQL 代码'
        },
        dropdown_ctrl_settings: {
            sign_in: '登录',
            new_project: '新建项目',
            keyboard_shortcuts: '键盘快捷键',
            languages: '语言'
        },
        dropdown_ctrl_info_resources: {
            feedback: '反馈',
            keyboard_shortcuts: '键盘快捷键',
            languages: '语言',
            homepage: '主页'
        },
        n: {
            default: '加载中…',
            file_ready_to_download: '文件已准备好下载',
            code_copied: '代码已复制',
            link_copied: '链接已复制',
            please_enter_message: '请输入消息',
            invalid_email: '电子邮件地址无效',
            something_wrong_contact: '出错了。请尝试重新加载页面或联系我们。',
            something_wrong: '出错了。请尝试重新加载页面。',
            sending: '发送中…',
            request_sent: '请求已发送。谢谢！'
        }
    }
};

export const zh_CNMeta = {
    lang_origin: '简体中文',
    lang_eng: 'Simplified Chinese',
    lang_code: 'zh_CN',
};
